/// <reference path="../../../../Scripts/typings/jquery/jquery.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/organizationmanager/viewmodels/userdata',["require", "exports", "plugins/dialog", "common/viewmodelbase"], function (require, exports, Dialog, Model) {
    "use strict";
    var UserDataViewModel = (function (_super) {
        __extends(UserDataViewModel, _super);
        function UserDataViewModel() {
            _super.call(this);
            this.userData = "";
            this.title = $.t("app:modules.organizationmanager.headline_titleUserdata", { ifMissing: "Benutzerdaten" });
            ko.track(this);
        }
        //#region override
        UserDataViewModel.prototype.onActivated = function (context) {
            this.userData = context.callingParameters.get("unknown");
            //$("#userData").focus();
        };
        UserDataViewModel.prototype.selectUserData = function () {
            $("#userData").select();
        };
        UserDataViewModel.prototype.close = function () {
            Dialog.close(this);
        };
        return UserDataViewModel;
    }(Model.ViewModelBase));
    return UserDataViewModel;
});

